export default __webpack_public_path__ + "static/media/stat1.9506b0a4.svg";